import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.subjects.item');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

@Component({
    selector: 'wiz-page-admin-subjects-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.subjects.item/view.scss */
:host {
  display: block;
  width: 100%;
}

.subject-detail-page {
  position: relative;
}

.subject-detail-backlink {
  font-weight: 600;
}

.subject-detail-hero,
.subject-detail-card {
  box-shadow: 0 22px 56px rgba(15, 23, 42, 0.07);
}

.subject-detail-hero {
  position: relative;
  overflow: hidden;
  background: radial-gradient(circle at top right, rgba(99, 102, 241, 0.2), transparent 24%), radial-gradient(circle at left center, rgba(56, 189, 248, 0.12), transparent 22%), linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(244, 247, 255, 0.96));
}

.subject-detail-hero__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
}

.subject-detail-hero__eyebrow,
.subject-detail-card__eyebrow {
  color: #6366f1;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.subject-detail-hero__identity {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
}

.subject-detail-hero__code {
  display: inline-flex;
  align-items: center;
  min-height: 27px;
  padding: 0.25rem 0.62rem;
  border: 1px solid #dbe3ef;
  border-radius: 999px;
  background: rgba(248, 250, 252, 0.96);
  color: #526077;
  font-size: 12px;
  font-weight: 750;
  letter-spacing: 0.01em;
}

.subject-detail-hero__title {
  margin-top: 0.7rem;
  color: #0f172a;
  font-size: 31px;
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: -0.04em;
}

.subject-detail-hero__desc,
.subject-detail-card__desc {
  margin-top: 0.8rem;
  color: #64748b;
  font-size: 14px;
  line-height: 1.7;
}

.subject-detail-hero__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.6rem;
  margin-top: 1rem;
}

.subject-detail-hero__meta-item {
  color: #64748b;
  font-size: 13px;
  font-weight: 600;
}

.subject-detail-hero__actions {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
}

.subject-detail-hero__stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
  margin-top: 1.45rem;
}

.subject-detail-stat {
  padding: 0.9rem 1rem;
  border-radius: 18px;
  border: 1px solid rgba(224, 231, 255, 0.96);
  background: rgba(255, 255, 255, 0.82);
}

.subject-detail-stat span {
  display: block;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.subject-detail-stat strong {
  display: block;
  margin-top: 0.32rem;
  color: #172554;
  font-size: 17px;
  font-weight: 800;
}

.subject-detail-card {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.99), rgba(248, 250, 252, 0.97));
}

.subject-detail-card__title {
  margin-top: 0.72rem;
  color: #0f172a;
  font-size: 20px;
  line-height: 1.3;
  font-weight: 800;
}

.subject-detail-label {
  display: block;
  margin-bottom: 0.45rem;
  color: #334155;
  font-size: 13px;
  font-weight: 700;
}

.subject-detail-input,
.subject-detail-textarea {
  display: block;
  width: 100%;
  border-radius: 16px;
  border: 1px solid rgba(203, 213, 225, 0.96);
  background: rgba(255, 255, 255, 0.98);
  color: #0f172a;
  font-size: 14px;
  padding: 0.78rem 0.95rem;
  outline: none;
  transition: border-color 180ms ease, box-shadow 180ms ease;
}

.subject-detail-input:focus,
.subject-detail-textarea:focus {
  border-color: rgba(99, 102, 241, 0.58);
  box-shadow: 0 0 0 4px rgba(99, 102, 241, 0.12);
}

.subject-detail-input--readonly {
  border-color: rgba(226, 232, 240, 0.98);
  background: rgba(241, 245, 249, 0.88);
  color: #475569;
}

.subject-detail-input--select {
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, #64748b 50%), linear-gradient(135deg, #64748b 50%, transparent 50%);
  background-position: calc(100% - 1rem) calc(50% - 0.16rem), calc(100% - 0.72rem) calc(50% - 0.16rem);
  background-size: 0.36rem 0.36rem, 0.36rem 0.36rem;
  background-repeat: no-repeat;
  padding-right: 2.2rem;
}

.subject-detail-textarea {
  min-height: 110px;
  resize: vertical;
}

.subject-detail-primary {
  box-shadow: 0 16px 30px rgba(79, 70, 229, 0.18);
}

.subject-detail-secondary {
  border-radius: 14px;
  border: 1px solid rgba(203, 213, 225, 0.96);
  background: rgba(255, 255, 255, 0.96);
  color: #334155;
  font-size: 13px;
  font-weight: 600;
  padding: 0.78rem 0.9rem;
  transition: background-color 180ms ease, border-color 180ms ease, transform 180ms ease;
}

.subject-detail-secondary:hover {
  background: rgb(248, 250, 252);
  border-color: rgba(148, 163, 184, 0.9);
}

.subject-detail-danger {
  box-shadow: 0 10px 24px rgba(244, 63, 94, 0.08);
}

.subject-detail-url-card {
  display: flex;
  min-height: 100%;
  flex-direction: column;
}

.subject-detail-url-expiry {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
  padding: 0.85rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
}

.subject-detail-url-expiry span {
  color: #64748b;
  font-size: 13px;
  font-weight: 700;
}

.subject-detail-url-expiry strong {
  color: #0f172a;
  font-size: 13px;
  font-weight: 750;
  text-align: right;
}

.subject-detail-url-actions {
  margin-top: auto;
  padding-top: 1rem;
}

.subject-detail-actiongrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
}

.subject-detail-info {
  display: grid;
  gap: 0.8rem;
}

.subject-detail-info__row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.9rem 1rem;
  border-radius: 16px;
  background: rgba(248, 250, 252, 0.95);
  border: 1px solid rgba(226, 232, 240, 0.95);
}

.subject-detail-info__label {
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
}

.subject-detail-info__value {
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
}

.subject-detail-forms__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.subject-detail-forms__count {
  flex: 0 0 auto;
  border-radius: 999px;
  background: #eef2ff;
  color: #4f46e5;
  font-size: 12px;
  font-weight: 800;
  padding: 0.42rem 0.7rem;
}

.subject-detail-forms__error {
  margin-top: 1rem;
  border-radius: 14px;
  background: #fff1f2;
  color: #be123c;
  font-size: 12px;
  padding: 0.85rem 1rem;
}

.subject-detail-forms {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.85rem;
  margin-top: 1.15rem;
}

.subject-detail-formcard {
  display: flex;
  min-width: 0;
  flex-direction: column;
  border: 1px solid rgba(226, 232, 240, 0.98);
  border-radius: 20px;
  background: radial-gradient(circle at right top, rgba(99, 102, 241, 0.08), transparent 28%), #fff;
  padding: 1rem;
}

.subject-detail-formcard__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.subject-detail-formcard__audience {
  color: #6366f1;
  font-size: 11px;
  font-weight: 850;
  letter-spacing: 0.04em;
}

.subject-detail-formcard h3 {
  margin-top: 0.38rem;
  color: #0f172a;
  font-size: 16px;
  font-weight: 850;
}

.subject-detail-formcard__status {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 0.36rem 0.6rem;
  font-size: 10px;
  font-weight: 800;
}

.subject-detail-formcard > p {
  min-height: 2.8rem;
  margin-top: 0.65rem;
  color: #64748b;
  font-size: 12px;
  line-height: 1.6;
}

.subject-detail-formcard__meta {
  display: grid;
  grid-template-columns: 0.75fr 0.65fr 1.25fr;
  gap: 0.5rem;
  margin-top: 0.85rem;
}

.subject-detail-formcard__meta span {
  min-width: 0;
  border-radius: 12px;
  background: #f8fafc;
  padding: 0.6rem;
}

.subject-detail-formcard__meta small,
.subject-detail-formcard__meta strong {
  display: block;
}

.subject-detail-formcard__meta small {
  color: #8492a6;
  font-size: 10px;
  font-weight: 700;
}

.subject-detail-formcard__meta strong {
  overflow: hidden;
  margin-top: 0.24rem;
  color: #334155;
  font-size: 11px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.subject-detail-formcard__stages {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem;
  margin-top: 0.65rem;
}

.subject-detail-formcard__stages > span {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 0.5rem 0.55rem;
}

.subject-detail-formcard__stages small {
  color: #64748b;
  font-size: 10px;
  font-weight: 700;
}

.subject-detail-formcard__stages strong {
  flex: 0 0 auto;
  border-radius: 999px;
  padding: 0.2rem 0.4rem;
  font-size: 9px;
  font-weight: 800;
}

.subject-detail-formcard__footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: auto;
  padding-top: 0.9rem;
}

.subject-detail-formcard__actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 0.45rem;
}

.subject-detail-formcard__download {
  display: inline-flex;
  min-height: 34px;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  color: #334155;
  font-size: 12px;
  font-weight: 800;
  padding: 0.52rem 0.7rem;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

.subject-detail-formcard__download:hover:not(:disabled) {
  border-color: #94a3b8;
  background: #f8fafc;
  color: #0f172a;
}

.subject-detail-formcard__download:disabled {
  cursor: not-allowed;
  border-color: #e2e8f0;
  background: #f8fafc;
  color: #a1aab8;
}

.subject-detail-formcard__spinner {
  width: 12px;
  height: 12px;
  border: 2px solid rgba(71, 85, 105, 0.25);
  border-top-color: #475569;
  border-radius: 999px;
  animation: subject-detail-formcard-spin 0.75s linear infinite;
}

.subject-detail-formcard__button {
  border-radius: 12px;
  background: #4f46e5;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  padding: 0.58rem 0.78rem;
  box-shadow: 0 10px 24px rgba(79, 70, 229, 0.18);
}

@keyframes subject-detail-formcard-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 767px) {
  .subject-detail-hero__row {
    flex-direction: column;
  }
  .subject-detail-hero__title {
    font-size: 26px;
  }
  .subject-detail-hero__stats,
  .subject-detail-actiongrid {
    grid-template-columns: 1fr;
  }
  .subject-detail-hero__actions {
    width: 100%;
  }
  .subject-detail-danger {
    width: 100%;
  }
  .subject-detail-forms__head {
    flex-direction: column;
  }
  .subject-detail-forms {
    grid-template-columns: 1fr;
  }
  .subject-detail-formcard__meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
/* Compact admin presentation */
.subject-detail-page {
  width: min(100%, 1120px);
  padding: 20px;
}

.subject-detail-page > .mb-5 {
  margin-bottom: 12px;
}

.subject-detail-hero,
.subject-detail-card {
  border-color: #e2e8f0;
  border-radius: 12px;
  background: #fff;
  box-shadow: none;
}

.subject-detail-hero {
  padding: 16px;
}

.subject-detail-hero__row {
  align-items: center;
}

.subject-detail-hero__title {
  margin: 0;
  color: #111827;
  font-size: 24px;
  font-weight: 750;
}

.subject-detail-hero__meta {
  margin-top: 8px;
}

.subject-detail-card {
  padding: 16px;
}

.subject-detail-card__title {
  margin: 0;
  color: #1f2937;
  font-size: 16px;
  font-weight: 700;
}

.subject-detail-card__desc {
  margin-top: 5px;
  font-size: 13px;
  line-height: 1.5;
}

.subject-detail-form {
  margin-top: 12px;
  gap: 12px;
}

.subject-detail-input,
.subject-detail-textarea {
  padding: 9px 11px;
  border-radius: 8px;
}

.subject-detail-input:focus,
.subject-detail-textarea:focus {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.subject-detail-textarea {
  min-height: 82px;
}

.subject-detail-primary,
.subject-detail-danger {
  border-radius: 8px;
  box-shadow: none;
}

.subject-detail-secondary {
  padding: 9px 10px;
  border-radius: 8px;
}

.subject-detail-info {
  gap: 0;
  margin-top: 10px;
}

.subject-detail-info__row {
  padding: 10px 2px;
  border: 0;
  border-bottom: 1px solid #eef0f3;
  border-radius: 0;
  background: transparent;
}

.subject-detail-info__row:last-child {
  border-bottom: 0;
}

.subject-detail-forms {
  gap: 10px;
  margin-top: 12px;
}

.subject-detail-forms__count {
  padding: 0;
  border-radius: 0;
  background: transparent;
  color: #64748b;
  font-weight: 600;
}

.subject-detail-formcard {
  padding: 14px;
  border-radius: 10px;
  background: #fff;
}

.subject-detail-formcard h3 {
  margin-top: 4px;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 750;
}

.subject-detail-formcard__audience {
  color: #64748b;
  font-size: 11px;
  letter-spacing: 0;
}

.subject-detail-formcard__meta {
  margin-top: 10px;
}

.subject-detail-formcard__meta span {
  padding: 8px;
  border-radius: 7px;
}

.subject-detail-formcard__button {
  padding: 8px 10px;
  border-radius: 7px;
  box-shadow: none;
}

.subject-detail-formcard__download {
  min-height: 32px;
  padding: 7px 9px;
  border-radius: 7px;
}

@media (max-width: 767px) {
  .subject-detail-page {
    padding: 16px;
  }
  .subject-detail-hero__row {
    align-items: stretch;
  }
}
@media (min-width: 1280px) {
  .subject-detail-forms {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
/* Unified admin visual hierarchy */
.subject-detail-page {
  margin: 0 auto;
  padding: 24px 28px 40px;
  color: var(--admin-text, #334155);
}

.subject-detail-backlink {
  color: var(--admin-text-muted, #64748b);
}

.subject-detail-backlink:hover {
  color: var(--admin-primary, #4f46e5);
}

.subject-detail-hero,
.subject-detail-card {
  border-color: var(--admin-border, #dce2ea);
  border-radius: 14px;
  background: var(--admin-surface, #fff);
  box-shadow: var(--admin-shadow-card, 0 1px 2px rgba(15, 23, 42, 0.04));
}

.subject-detail-hero {
  background: radial-gradient(circle at 92% 12%, var(--admin-primary-soft, #eef2ff), rgba(255, 255, 255, 0) 34%), var(--admin-surface, #fff);
}

.subject-detail-hero__eyebrow,
.subject-detail-card__eyebrow {
  color: var(--admin-primary, #4f46e5);
  letter-spacing: 0.08em;
}

.subject-detail-hero__title,
.subject-detail-card__title {
  color: var(--admin-text-strong, #111827);
}

.subject-detail-hero__title {
  font-size: 27px;
}

.subject-detail-hero__desc,
.subject-detail-card__desc,
.subject-detail-hero__meta-item {
  color: var(--admin-text-muted, #64748b);
}

.subject-detail-stat {
  border-color: var(--admin-border, #dce2ea);
  border-radius: 10px;
  background: var(--admin-surface-subtle, #f8fafc);
}

.subject-detail-card__title,
.subject-detail-forms__head h2 {
  display: flex;
  align-items: center;
}

.subject-detail-card__title::before,
.subject-detail-forms__head h2::before {
  width: 7px;
  height: 7px;
  margin-right: 8px;
  border-radius: 999px;
  background: var(--admin-primary, #4f46e5);
  content: "";
}

.subject-detail-info__row,
.subject-detail-formcard__meta span {
  border-color: var(--admin-border-soft, #edf1f5);
  background: var(--admin-surface-subtle, #f8fafc);
}

.subject-detail-formcard {
  --form-accent: var(--admin-text-muted, #64748b);
  --form-soft: var(--admin-surface-subtle, #f8fafc);
  overflow: hidden;
  border-color: var(--admin-border, #dce2ea);
  border-radius: 11px;
  background: radial-gradient(circle at 100% 0, var(--form-soft), rgba(255, 255, 255, 0) 42%), var(--admin-surface, #fff);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.035);
}

.subject-detail-formcard[data-form-code=original_survey] {
  --form-accent: var(--admin-primary, #4f46e5);
  --form-soft: var(--admin-primary-soft, #eef2ff);
}

.subject-detail-formcard[data-form-code=geriatric_depression] {
  --form-accent: var(--admin-success, #047857);
  --form-soft: var(--admin-success-soft, #ecfdf5);
}

.subject-detail-formcard[data-form-code=mmse] {
  --form-accent: var(--admin-warning, #b45309);
  --form-soft: var(--admin-warning-soft, #fffbeb);
}

.subject-detail-formcard__audience {
  color: var(--form-accent);
}

.subject-detail-formcard__status {
  border-color: transparent;
  background: var(--form-soft);
}

.subject-detail-formcard__button {
  border-color: var(--form-accent);
  background: var(--form-accent);
}

.subject-detail-primary {
  background: var(--admin-primary, #4f46e5);
}

.subject-detail-input,
.subject-detail-textarea {
  border-color: var(--admin-border, #dce2ea);
  border-radius: 9px;
  background: var(--admin-surface, #fff);
}

@media (max-width: 767px) {
  .subject-detail-page {
    padding: 16px 16px 32px;
  }
}`],
})
export class PageAdminSubjectsItemComponent implements OnInit {
    public id: string = '';
    public subject: any = null;
    public loading: boolean = true;
    public saving: boolean = false;
    public downloadingFormCode: string = '';

    constructor(@Inject( Service) public service: Service) { }

    private payload(data: any): any {
        if (data && data.data !== undefined) {
            return data.data;
        }
        return data || {};
    }

    public async ngOnInit() {
        await this.service.init();
        this.id = WizRoute.segment.id;
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("get", { id: this.id });
        this.loading = false;
        if (code === 200 && data) {
            this.subject = this.payload(data);
        } else {
            alert((data && data.message) || '조회 실패');
            this.service.href('/admin/subjects');
        }
        await this.service.render();
    }

    public surveyUrl(): string {
        if (!this.subject) return '';
        return location.origin + '/s/' + this.subject.token;
    }

    public async copyUrl() {
        const url = this.surveyUrl();
        try {
            await navigator.clipboard.writeText(url);
            alert('URL이 복사되었습니다.');
        } catch (e) {
            prompt('URL을 복사하세요.', url);
        }
    }

    public async save() {
        const name = String(this.subject.name || '').trim();
        if (!name) {
            alert('이름을 입력해주세요.');
            return;
        }
        this.subject.name = name;
        this.saving = true;
        await this.service.render();
        const { code, data } = await wiz.call("update", {
            id: this.id,
            name: name,
            gender: this.subject.gender || 'O',
            birth: this.subject.birth || '',
            memo: this.subject.memo || ''
        });
        this.saving = false;
        if (code === 200) {
            alert('저장되었습니다.');
            await this.load();
        } else {
            alert((data && data.message) || '저장 실패');
            await this.service.render();
        }
    }

    public async regenerate() {
        if (!confirm('URL 토큰을 재발급하면 기존 URL은 더 이상 사용할 수 없습니다.\n진행하시겠습니까?')) return;
        const { code, data } = await wiz.call("regenerate_token", { id: this.id });
        if (code === 200) {
            alert('새 URL이 발급되었습니다.');
            await this.load();
        } else {
            alert((data && data.message) || '재발급 실패');
        }
    }

    public async extend(days: number) {
        const { code, data } = await wiz.call("extend_expiry", { id: this.id, days: days });
        if (code === 200) {
            alert(days + '일 연장되었습니다.');
            await this.load();
        } else {
            alert((data && data.message) || '연장 실패');
        }
    }

    public async del() {
        if (!confirm('이 대상자를 삭제하시겠습니까? 응답 데이터도 함께 삭제됩니다.')) return;
        const { code, data } = await wiz.call("delete", { id: this.id });
        if (code === 200) {
            this.service.href('/admin/subjects');
        } else {
            alert((data && data.message) || '삭제 실패');
        }
    }

    public formPath(form: any): string {
        if (!form || !form.code) return '/admin/subjects/' + this.id;
        return '/admin/subjects/' + this.id + '/forms/' + form.code;
    }

    public formAudienceLabel(form: any): string {
        return form && form.audience === 'admin_only' ? '관리자 전용' : '대상자 · 관리자';
    }

    public formTitle(form: any): string {
        if (form && form.code === 'original_survey') {
            return '한의 검진 설문(CRF)';
        }
        return (form && form.title) || '설문';
    }

    public formStatusBadge(status: string): string {
        const map: any = {
            'pending': 'bg-slate-100 text-slate-700',
            'in_progress': 'bg-amber-100 text-amber-700',
            'admin_pending': 'bg-indigo-100 text-indigo-700',
            'submitted': 'bg-emerald-100 text-emerald-700'
        };
        return map[status] || map.pending;
    }

    public formStatusLabel(status: string): string {
        const map: any = {
            'pending': '미작성',
            'in_progress': '작성 중',
            'admin_pending': '관리자 기록 대기',
            'submitted': '완료'
        };
        return map[status] || '미작성';
    }

    public formActionLabel(form: any): string {
        if (!form || !form.schema_ready) return '구조 확인';
        if (
            form.code === 'original_survey'
            && form.admin_status !== 'submitted'
            && form.subject_status === 'submitted'
        ) return '관리자 기록 작성';
        if (form.status === 'submitted') return '내용 수정';
        if (form.status === 'in_progress') return '이어서 작성';
        return form.audience === 'admin_only' ? '검사 작성' : '대신 작성';
    }

    public canDownloadForm(form: any): boolean {
        const status = form?.overall_status || form?.status;
        return !!form && status === 'submitted' && form.schema_ready;
    }

    private parseFilename(contentDisposition: string | null, fallback: string): string {
        if (!contentDisposition) return fallback;
        const utfMatch = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
        if (utfMatch && utfMatch[1]) {
            try {
                return decodeURIComponent(utfMatch[1]);
            } catch (e) {
                return utfMatch[1];
            }
        }
        const asciiMatch = contentDisposition.match(/filename=\"?([^\";]+)\"?/i);
        if (asciiMatch && asciiMatch[1]) {
            return asciiMatch[1];
        }
        return fallback;
    }

    public async downloadForm(form: any) {
        if (
            !this.subject ||
            !this.subject.id ||
            !this.canDownloadForm(form) ||
            this.downloadingFormCode
        ) return;

        this.downloadingFormCode = form.code;
        await this.service.render();

        try {
            const path = (
                '/api/admin/subjects/' +
                encodeURIComponent(this.subject.id) +
                '/forms/' +
                encodeURIComponent(form.code) +
                '/xlsx'
            );
            const response = await fetch(path, {
                method: 'GET',
                credentials: 'same-origin',
            });

            const contentType = response.headers.get('Content-Type') || '';
            if (!response.ok || contentType.includes('application/json')) {
                let message = '엑셀 다운로드에 실패했습니다.';
                try {
                    const body = await response.json();
                    if (body && body.data && body.data.message) {
                        message = body.data.message;
                    } else if (body && body.message) {
                        message = body.message;
                    }
                } catch (e) {}
                alert(message);
                return;
            }

            const blob = await response.blob();
            const fallback = (
                (this.subject.code || this.subject.id) +
                '-' +
                form.code +
                '.xlsx'
            );
            const filename = this.parseFilename(
                response.headers.get('Content-Disposition'),
                fallback,
            );
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
        } catch (e: any) {
            alert(
                '네트워크 오류: ' +
                (e && e.message ? e.message : e),
            );
        } finally {
            this.downloadingFormCode = '';
            await this.service.render();
        }
    }

    public statusBadge(status: string): string {
        const map: any = {
            'pending':     'bg-slate-100 text-slate-700',
            'in_progress': 'bg-amber-100 text-amber-700',
            'completed':   'bg-emerald-100 text-emerald-700',
            'expired':     'bg-rose-100 text-rose-700'
        };
        return map[status] || 'bg-slate-100 text-slate-700';
    }

    public statusLabel(status: string): string {
        const map: any = {
            'pending':     '미응답',
            'in_progress': '진행중',
            'completed':   '완료',
            'expired':     '만료'
        };
        return map[status] || status;
    }
}

export default PageAdminSubjectsItemComponent;